import {TourbookAction, TourbookMutation} from "./types";
import axios from "axios";

export default {
    [TourbookAction.LOAD]({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit(TourbookMutation.REQUEST);

            let {sortBy, sortDesc, page, itemsPerPage} = payload.options;

            axios.post('/tourbook', {
                sortBy,
                sortDesc,
                page,
                itemsPerPage,
                filter: payload.filter,
            })
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TourbookMutation.SUCCESS, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(TourbookMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
    [TourbookAction.RELEASE]({commit}, schedule) {
        return new Promise(
            (resolve, reject) => {
                commit(TourbookMutation.REQUEST);

                axios.put(`/tourbook/${schedule.id}/release`)
                    .then(() => {
                        commit(TourbookMutation.RELEASE_SUCCESS, schedule);

                        resolve(schedule);
                    })
                    .catch(err => {
                        commit(TourbookMutation.ERROR, err.response.data || err);
                        reject(err);
                    });
            }
        );
    },
    [TourbookAction.UPDATE]({commit}, {schedule, data}) {
        return new Promise(
            (resolve, reject) => {
                commit(TourbookMutation.REQUEST);

                axios
                    .put(
                        `/tourbook/${schedule.id}/itinerary`,
                        data,
                    )
                    .then(() => {
                        commit(TourbookMutation.UPDATE_SUCCESS, schedule);

                        resolve(schedule);
                    })
                    .catch((err) => {
                        commit(TourbookMutation.ERROR, err.response.data || err);

                        reject(err);
                    });
            }
        );
    },
};
